import React, { useRef } from "react";
import {
  Typography,
  useTheme,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";
import "react-medium-image-zoom/dist/styles.css";
import Divider from "@mui/material/Divider";
import "../JaldiLab.css";
import Image from "../../../components/ChapterImage/Image";
import {
  generateOrderedList,
  generateUnOrderedList,
  generateParagraphsWithHeading,
  referenceHtml,
  referenceTootKit,
  h1style,
  h2style,
  h3style,
  paraStyle,
  pointStyle,
  h4style,
  DividerBorderStyle,
  captionWithBorders,
  getTextContentHeading,
} from "./ChapterList";
import ArchitectureIcon from "@mui/icons-material/Architecture";
import FFJimg1 from "../../../assets/Images/Facilities for JUdges/FFJ img 1.png";
import objective from "../../../assets/SvgIcons/obj.svg";
import user from "../../../assets/SvgIcons/users.svg";
import adjacencies from "../../../assets/SvgIcons/adjacencies.svg";
import designConsideration from "../../../assets/SvgIcons/design-consideration.svg";
import FFJimg2 from "../../../assets/Images/FacilitiesForJudges2.jpg";
import CaptionWithBorders1 from "../../../components/ChapterImage/Image";
import relaxation1 from "../../../assets/Images/Facilities for JUdges/relaxation1.png";
import { ImageDesc58, ImageDesc59 } from "../../../utils/tmp/ImageDescription/FacililiesForJudgeID";

const FacilitiesForJudges = () => {
  const DesignConsiderations = {
    icon: <img src={designConsideration} />,
    heading: "Design Considerations",
    data: [
      "A common dining room/banquet hall with tables, chairs, and lounge chairs/sofas for social gatherings, must be provided.",
      "The lounge must have access to facilities such as a kitchenette/service pantry, and attached accessible washrooms.",
    ],
    isOrdered: false,
    isImage: true,
  };

  const theme = useTheme();

  return (
    <div>
      <Typography>
        <h1 style={h1style}>PART C - THE HANDBOOK</h1>
        <h2 style={h2style}>
          <span style={{ fontSize: "24px" }}>2. </span>
          ORGANIZATION AND DESIGN OF SPACES OF THE COURT COMPLEX
        </h2>
        <h3 style={h3style}>
          <span style={{ fontSize: "20px" }}>2.4. </span>
          Facilities for Judges
        </h3>
        <h3 id="judges-lounge" style={h3style}>
          <span style={{ fontSize: "20px" }}>2.4.</span>B. Judges’ Lounge
        </h3>{" "}
        <p style={paraStyle}>
          Within the Court Complex, a relaxation space or lounge must be
          provided for Judicial Officers to relax and unwind after the day’s
          work. Provisions for de-stressing and participating in relaxation
          activities help with ensuring the physical and psychological
          well-being of Judges.
        </p>
        {getTextContentHeading(DesignConsiderations)}
        <CaptionWithBorders1
          image={[FFJimg1]}
          caption={
            " Image 58: Example of a Judges’ lounge at Warangal District Court, Telangana"
          }
          creditLabel={"Source"}
          imageCredit={" Warangal Transformation Report"}
          zoomImgStyle={{ height: "500px" }}
          imageDescription={ImageDesc58}
        />
        <CaptionWithBorders1 image={[]} zoomImgStyle={{ height: "500px" }} />
        <CaptionWithBorders1
          image={[FFJimg2]}
          zoomImgStyle={{ height: "500px" }}
        />
        <CaptionWithBorders1
          image={[relaxation1]}
          caption={
            " Image 59: Examples of facilities to be provided for a lounge/relaxation area"
          }
          creditLabel="Source"
          imageCredit="officesnapshots.com"
          zoomImgStyle={{ height: "500px" }}
          imageDescription={ImageDesc59}
        />
        <DividerBorderStyle />
        <h3 id="res-quaters" style={h3style}>
          <span style={{ fontSize: "20px" }}>2.4.</span>C. Residential Quarters
          and Guest House
        </h3>
        <p style={paraStyle}>
          Adequate residential provisions must be provided for the Judges in
          each District Court. Additionally, a residential guest house must be
          provided for the use of Judges visiting from other states, or guests
          of local Judges. These facilities may additionally include
          recreational facilities such as a cultural centre, lounge,
          meditation/yoga hall, a swimming pool, gym, and other provisions for
          games, food, etc.
        </p>
        <p style={paraStyle}>
          These facilities may be located outside the premises of the Court
          Complex in instances where the site is not large enough to accommodate
          them. Special security must be provided to ensure the safety of the
          users/guests.
        </p>
      </Typography>
    </div>
  );
};

export default FacilitiesForJudges;
